import { Component } from '@angular/core'
import { Message, MessageService } from 'primeng/api'

@Component({
  selector: 'op-notification-service-ng',
  templateUrl: './ng-notification.component.html',
  styleUrls: ['./ng-notification.component.scss'],
})
export class NgNotificationHostComponent {
  constructor(public messageService: MessageService) {}

  closeMessage(message: Message): void {
    this.messageService.clear(message.key)
  }

  onMessageClick(message: Message): void {
    const fn = (message as { data: { onClick?: () => void } })?.data?.onClick
    if (typeof fn === 'function') fn()
  }
}
